import { render, staticRenderFns } from "./CheckboxCell.vue?vue&type=template&id=2565cee2&"
import script from "./CheckboxCell.vue?vue&type=script&lang=js&"
export * from "./CheckboxCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports